import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import SettingsService from "../../../service/settingsService";
import {toast} from "sonner";

export const useSettings = () => {

    const queryClient = useQueryClient();

    const {data: settings} = useQuery({
        queryKey: ["settings"],
        queryFn: ()=> SettingsService.getAll()
    })


    const {mutate: updateSettings} = useMutation({
        mutationKey: ["updateSettings"],
        mutationFn: (data)=> SettingsService.update(data),
        onSuccess: ()=> {
            queryClient.invalidateQueries("settings")
            toast.success("Настройки обновлены")
        },
    })

    return {
        settings,
        updateSettings
    }
}